// extracted by mini-css-extract-plugin
module.exports = {"tabWrapper":"tabWrapper___BL3v6"};